export default __webpack_public_path__ + "static/media/shaw.67c716a4.png";